import React, { useCallback } from 'react'

import { ContainerProps } from './types'

import InsuranceTypeRadio from './index.presentational'

const InsuranceTypeRadioContainer: React.FC<ContainerProps> = ({
  isChecked = false,
  onChange,
  ...props
}): React.ReactElement => {
  const onClick = useCallback(() => {
    onChange && onChange(!isChecked)
  }, [
    isChecked,
    onChange,
  ])

  return React.createElement(InsuranceTypeRadio, {
    ...props,
    isChecked,
    onClick,
  })
}

export * from './types'

export default InsuranceTypeRadioContainer
